<div class="account-modal d-flex h-100 position-relative">
    <button mat-dialog-close mat-icon-button class="close-btn">
        <mat-icon>close</mat-icon>
    </button>
    <!-- Add Group -->
    <div class="commodalbx w-100" *ngIf="item.action == 'addGroups' || item.action=='editGroup'">
        <h1 class="modaltitle"> {{item.action == 'addGroups' ? 'Add Group' : 'Update Group'}}</h1>
        <form (ngSubmit)="f.form.valid && onSubmitGroup()" #f="ngForm">
            <mat-form-field appearance="legacy">
                <mat-label>Group Name</mat-label>
                <input matInput placeholder="Groups Name" [(ngModel)]="modalGroup.groupName" name="groupName" required>
            </mat-form-field>
            <button type="submit" mat-flat-button color="primary" class="text-uppercase" [disabled]="!f.form.valid">
                {{item.action == 'addGroups' ? 'Add' : 'Update'}}</button>
        </form>
    </div>
    <!-- Add Categories -->
    <div class="commodalbx w-100" *ngIf="item.action == 'addCategory'|| item.action=='editcategory'">
        <h1 class="modaltitle">{{item.action == 'addCategory' ? 'Add Category' : 'Update Category'}}</h1>
        <form (ngSubmit)="f.form.valid && onSubmitCategory()" #f="ngForm">
            <mat-form-field appearance="legacy">
                <mat-label>Select Group</mat-label>
                <mat-select [(ngModel)]="Category.groupId" name="groupId" required [compareWith]="compareFn">
                    <fuse-mat-select-search name="search" [(ngModel)]="Grouptt">
                    </fuse-mat-select-search>
                    <mat-option *ngFor="let list of groupList" [value]="list.groupId">{{list.groupName}} </mat-option>

                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="legacy">
                <mat-label>Category Name</mat-label>
                <input matInput placeholder="Category Name" [(ngModel)]="Category.categoryName" name="categoryName"
                    required>
            </mat-form-field>
            <button type="submit" mat-flat-button color="primary" class="text-uppercase"
                [disabled]="!f.form.valid">{{item.action == 'addCategory' ? 'Add' : 'Update'}}</button>
        </form>
    </div>
    <!-- Add Sub Categories -->
    <div class="commodalbx w-100" *ngIf="item.action == 'addSubCategory'|| item.action=='editsubCategory'">
        <h1 class="modaltitle">{{item.action == 'addSubCategory' ? 'Add Sub Category' : 'Update Sub Category'}}</h1>
        <form (ngSubmit)="f.form.valid && onSubmitSubCategory()" #f="ngForm">
            <mat-form-field appearance="legacy">
                <mat-label>Select Group</mat-label>
                <mat-select [(ngModel)]="SubCategory.groupId" (selectionChange)="groupDropDown(SubCategory.groupId)"
                    name="groupId" #groupId="ngModel" required [compareWith]="compareFn">
                    <mat-option *ngFor="let list of groupList" [value]="list.groupId">{{list.groupName}}</mat-option>

                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="legacy">
                <mat-label>Select Category</mat-label>
                <mat-select [(ngModel)]="SubCategory.categoryId" name="CategoryName" required [compareWith]="compareFn">
                    <mat-option *ngFor="let sublist of CategoryDropList" [value]="sublist.categoryId">
                        {{sublist.categoryName}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="legacy">
                <mat-label>Sub Category Name</mat-label>
                <input matInput placeholder="Sub Category Name" [(ngModel)]="SubCategory.subCategoryName"
                    name="SubCategoryName" required>
            </mat-form-field>
            <button type="submit" mat-flat-button color="primary" class="text-uppercase"
                [disabled]="!f.form.valid">{{item.action == 'addSubCategory' ? 'Add' : 'Update'}}</button>
        </form>
    </div>
    <!-- Add File Type -->
    <div class="commodalbx w-100" *ngIf="item.action == 'addFileType' || item.action=='editfileType'">
        <h1 class="modaltitle"> {{item.action == 'addFileType' ? 'Add File Type' : 'Update File Type'}}</h1>
        <form (ngSubmit)="f.form.valid && onSubmitFileType()" #f="ngForm">
            <div class="row">
                <div class="col-md-6">

                    <mat-form-field appearance="legacy">
                        <mat-label>File Type Name</mat-label>
                        <mat-select [(ngModel)]="FileType.fileTypeName" name="fileTypeExtension" required>
                            <mat-option *ngFor="let list of fileTypeNameLists" [value]="list.fileTypeName">
                                {{list?.fileTypeName}}</mat-option>
                        </mat-select>
                    </mat-form-field>

                </div>
                <div class="col-md-6">
                    <mat-form-field appearance="legacy">
                        <mat-label>File Type Extension</mat-label>
                        <input matInput placeholder="File Type Name" [(ngModel)]="FileType.fileTypeExtension"
                            name="fileTypeName" required>
                    </mat-form-field>

                </div>

            </div>

            <div class="row">
                <div class="col-md-6">
                    <mat-form-field appearance="legacy">
                        <mat-label>Max Size</mat-label>
                        <input matInput placeholder="Max Size" [(ngModel)]="FileType.maxSize" name="maxSize"
                            type="number" required>
                    </mat-form-field>
                </div>
                <div class="col-md-6">
                    <mat-form-field appearance="legacy">
                        <mat-label>MB</mat-label>
                        <mat-select [(ngModel)]="FileType.sizeDigit" name="sizeDigit" required>
                            <mat-option value="KB">KB</mat-option>
                            <mat-option value="MB">MB</mat-option>
                            <mat-option value="GB">GB</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <button type="submit" mat-flat-button color="primary" class="text-uppercase"
                [disabled]="!f.form.valid">{{item.action == 'addFileType' ? 'Add' : 'Update'}}</button>
        </form>
    </div>
    <!-- Add File Tyes -->
    <div class="commodalbx addfile-modal w-100"
        *ngIf="item.action == 'addFileDocument' || item.action == 'editFileDocument' || item.action == 'uploadNewVersion'">
        <h1 class="modaltitle" *ngIf="item.action != 'uploadNewVersion'">{{item.action == 'addFileDocument'? 'Add New'
            :'Edit'}}</h1>
        <h1 class="modaltitle" *ngIf="item.action == 'uploadNewVersion'">Upload New Version</h1>
        <form #f3="ngForm"
            (ngSubmit)="f3.form.valid && onSubmitAddFileDoc($event, addDocument?.documentList[addDocument?.documentList?.length-1]?.documentName)">
            <div *ngIf="item.action == 'editFileDocument' || item.action == 'uploadNewVersion'" class="mt-4">
                <mat-form-field appearance="legacy">
                    <mat-label>Select Group</mat-label>
                    <mat-select [(ngModel)]="addDocument.documentList[0].groupId" (selectionChange)="groupDropDown(addDocument.documentList[0].groupId)"
                        name="groupId" #groupId="ngModel" required [compareWith]="compareFn"
                        [disabled]="item.action == 'uploadNewVersion'">
                        <mat-option *ngFor="let list of addGroupList" [value]="list.groupId">{{list.groupName}}
                        </mat-option>

                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="legacy">
                    <mat-label>Select Category</mat-label>
                    <mat-select [(ngModel)]="addDocument.documentList[0].categoryId"
                        (selectionChange)="CategoryDropDown(addDocument.documentList[0].categoryId)" name="categoryId"
                        #categoryId="ngModel" required [compareWith]="compareFn"
                        [disabled]="item.action == 'uploadNewVersion'">
                        <mat-option *ngFor="let catList of CategoryDropList" [value]="catList.categoryId">
                            {{catList.categoryName}}</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="legacy">
                    <mat-label>Select Sub Category</mat-label>
                    <mat-select [(ngModel)]="addDocument.documentList[0].subCategoryId" name="subCategoryId" #subCategoryId="ngModel"
                        required [compareWith]="compareFn" [disabled]="item.action == 'uploadNewVersion'">

                        <mat-option *ngFor="let sublist of subCategoryList" [value]="sublist.subCategoryId">
                            {{sublist.subCategoryName}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <ng-container *ngIf="item.action == 'addFileDocument'">
                <p class="breadcrume-txt">{{item?.data?.group?.groupName}} > {{item?.data?.category?.categoryName}} >
                    {{item?.data?.subCategory?.subCategoryName}}</p>
            </ng-container>
            <div class="uploadFile w-100">
                <label>Add an Attachment
                    <input type="file" #myFileInput
                        (change)="fileUpload($event, imgUploadJson, addDocument.documentList)" name="Document" required>
                </label>
                <mat-error>{{addDocument?.documentList?.fileSizeError}}
                </mat-error>
                <mat-error *ngIf="f3.submitted && addDocument?.documentList?.length == 0">
                    Please Upload Attachment
                </mat-error>
                <!-- All Uploded files -->
                <div class="uploadfile-nameicon"
                    *ngIf="addDocument?.documentList?.length > 0 || item.action == 'addFileDocument'">
                    <div *ngFor="let list of addDocument.documentList"
                        class="d-flex w-100 justify-content-between pt-2">
                        <div class="filename d-flex align-items-center" style="width: 80%;"><img
                                src="/assets/images/{{list?.documentType}}-icon.png" alt="" style="margin-right: 10px">
                            <span class="text-truncate">{{list.documentName}}</span>
                        </div>
                        <a routerLink="." (click)="fileUploadRemove(addDocument, list)" class="delete-doc">
                            Delete
                        </a>
                    </div>
                </div>
                <!-- upload process bar -->
                <div *ngIf="imgProcessBar?.percentDone && imgProcessBar?.percentDone != 100"
                    class="progressbar-outer position-relative">
                    <mat-progress-bar [mode]="imgProcessBar?.percentDone ? 'determinate' : 'determinate'"
                        [value]="imgProcessBar?.percentDone">
                    </mat-progress-bar>
                    <small>Uploading.... {{imgProcessBar?.percentDone}}%</small>
                </div>
            </div>
            <!-- <div class="datePicker">
                <label style="position: relative; top: 4px;">Validity</label>
                <mat-form-field appearance="legacy" style="width:118px;">
                    <input matInput [matDatepicker]="pickerCheque" [(ngModel)]="addDocument.availableTillDate"
                        name="availableTillDate" [min]="minDate">
                    <mat-datepicker-toggle matSuffix [for]="pickerCheque"></mat-datepicker-toggle>
                    <mat-datepicker #pickerCheque></mat-datepicker>
                </mat-form-field>
            </div> -->
            <div class="tags d-flex">
                <label>Tags <img src="assets/images/tag.svg" alt=""></label>
                <mat-form-field class="example-chip-list" appearance="fill">
                    <mat-chip-list #chipList>
                        <mat-chip *ngFor="let tag of addDocument?.tagList" (removed)="remove(tag)" [selected]="tag"
                            [value]="tag">
                            {{tag.tagName}}
                            <button matChipRemove>
                                <mat-icon>close</mat-icon>
                            </button>
                        </mat-chip>
                        <input [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                            [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="add($event)"
                            placeholder="Add New">
                    </mat-chip-list>
                </mat-form-field>
            </div>
            <div class="remark">
                <mat-form-field appearance="legacy">
                    <mat-label>Add remark</mat-label>
                    <textarea matInput type="text" [(ngModel)]="addDocument.documentRemarks" #documentRemarks="ngModel"
                        name="documentRemarks"></textarea>
                </mat-form-field>
            </div>
            <button type="submit" mat-flat-button color="primary" class="text-uppercase"
                [disabled]="f3.form.invalid">{{item.action == 'addFileDocument'? 'ADD':'UPDATE'}}</button>
        </form>
    </div>
    <!-- Share File -->
    <div class="share-file commodalbx w-100" *ngIf="item.action == 'shareFile'">
        <h1 class="modaltitle" [ngStyle]="{'margin-bottom' : item?.pageName == 'groups' ? '5px' : '22px'}">
            {{item?.pageName == 'groups' ? 'Share Group' : 'Share File'}}</h1>
        <strong *ngIf="item?.pageName == 'groups'" class="share-grname d-block">{{item?.data?.groupName}}</strong>
        <div class="filename d-flex align-items-center" *ngIf="item?.data?.documentName"><img
                src="/assets/images/{{item?.data?.documentTypeExtension}}-icon.png" alt=""> {{item?.data?.documentName}}
        </div>
        <form #f="ngForm" (ngSubmit)="f.form.valid && shareFileSubmit()">
            <mat-form-field class="tocan" floatLabel=never>
                <input placeholder="Email or Name" matInput #fruitInput [formControl]="fruitCtrl"
                    [matAutocomplete]="auto" [matChipInputFor]="chipList" 
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes" >
                <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                    <mat-option *ngFor="let fruit of filteredFruits | async" [value]="fruit">
                        {{fruit}}
                    </mat-option>
                </mat-autocomplete>
                <span matPrefix class="preset">To</span>
                <span matSuffix class="sufset" *ngIf="item?.pageName != 'groups'">Can view <mat-icon>keyboard_arrow_down
                    </mat-icon></span>
            </mat-form-field>
            <mat-chip-list #chipList>
                <mat-chip *ngFor="let list of emails" (removed)="removeShareChip(list)">
                    {{list?.userEmail}}
                    <button matChipRemove>
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-chip>
            </mat-chip-list>
            <ng-container *ngIf="item?.pageName != 'groups'">
                <div class="datePicker d-flex" style="width: 180px;">
                    <mat-form-field appearance="legacy">
                        <input matInput [matDatepicker]="pickerCheque" [(ngModel)]="shareModel.availableTillDate"
                            name="availableTillDate" [min]="minDate" (click)="pickerCheque.open()">
                        <mat-datepicker-toggle matSuffix [for]="pickerCheque"></mat-datepicker-toggle>
                        <mat-datepicker #pickerCheque></mat-datepicker>
                        <span matPrefix class="preset">Validity</span>
                    </mat-form-field>
                </div>
                <textarea placeholder="Add a comment" [(ngModel)]="shareModel.DocumentRemarks"
                    name="DocumentRemarks"></textarea>
            </ng-container>
            <!-- <mat-checkbox [(ngModel)]="shareModel.isPassword" name="isPassword">Secure with password</mat-checkbox>
            <mat-form-field appearance="legacy" *ngIf="shareModel.isPassword">
                <input type="password" matInput [(ngModel)]="shareModel.documentpassword" name="documentpassword">
            </mat-form-field> -->
            <div class="share-everyone">
                <mat-checkbox [(ngModel)]="shareModel.IsShareWithEveryOne" (change)="shareallchange($event)"
                name="IsShareWithEveryOne">Share With Everyone</mat-checkbox>
            </div>
            <div class="botbtn">
                <button type="submit" mat-flat-button color="primary" class="text-uppercase"
                    [disabled]="emails?.length == 0 && !shareModel.IsShareWithEveryOne">{{getSharList && getSharList?.length > 0 ? 'Update' :
                    'Add'}}</button>
            </div>
        </form>
    </div>
    <!-- View Document -->
    <div class="viewdoc-bx w-100 d-flex" *ngIf="item.action == 'viewDoc'">
        <div class="leftbar text-center">
            <iframe [src]="docData?.documentData | safe" class="iframebx"
                *ngIf="docData?.documentTypeExtension != 'jpg' && docData?.documentTypeExtension != 'png'"></iframe>
            <img [src]="docData?.documentData" alt=""
                *ngIf="docData?.documentTypeExtension == 'jpg' || docData?.documentTypeExtension == 'png'"
                style="width:50%">
        </div>
        <div class="rightbar">
            <h2>{{docData?.documentName}}</h2>
            <div class="insbox">
                <ul class="d-flex m-0 p-0">
                    <li><a routerLink="" (click)="shareFile(docData)"><img src="assets/images/share.svg" alt=""
                                style="width:23px; height: 23px;"></a></li>
                    <!-- <li><a routerLink=""><img src="assets/images/comment.svg" alt=""></a></li> -->
                    <li><a routerLink="" (click)="deleteDoc(docData)"
                            *ngIf="item?.pageName != 'share' && item?.data?.pageName != 'share'"><img
                                src="assets/images/delete.svg" alt=""></a>
                    </li>
                    <!-- <li><a routerLink=""><img src="assets/images/menu.svg" alt=""></a></li> -->
                </ul>

                <mat-tab-group>
                    <mat-tab label="Details">
                        <mat-dialog-content>
                            <div class="dettop d-flex flex-wrap">
                                <div class="col-6 textbx">
                                    <label>Type</label>
                                    {{docData?.documentType}}
                                </div>
                                <div class="col-6 textbx">
                                    <label>Owner</label>
                                    <div class="d-flex align-items-center">
                                        <img src="{{docData?.createdByImagePath ? docData?.createdByImagePath : 'assets/images/userLogo.png'}}"
                                            alt=""> {{docData?.createdBy}}
                                    </div>
                                </div>
                                <div class="col-6 textbx">
                                    <label>Size</label>
                                    <ng-container *ngIf="docData?.documentSize < 1024">
                                        {{docData?.documentSize | number : '1.2-2'}} KB </ng-container>
                                    <ng-container *ngIf="docData?.documentSize >1024">
                                        {{docData?.documentSize/1024 | number : '1.2-2'}} MB </ng-container>
                                    <!-- 27 MB (28,589,575 bytes) -->
                                </div>
                                <div class="col-6 textbx">
                                    <label>Modified</label>
                                    {{docData?.updatedDate | date}} by me
                                </div>
                                <div class="col-12 textbx" *ngIf="docData?.documentRemarks">
                                    <label>Remark</label>
                                    {{docData?.documentRemarks}}
                                </div>
                                <!-- <div class="col-6 textbx">
                                    <label>Created on</label>
                                    {{docData?.createdDate | date}}
                                </div> -->
                            </div>
                            <div class="la-comment">
                                <ng-container *ngIf="commentList?.length > 0">
                                    <h4>Latest Comments</h4>
                                    <div class="box" *ngFor="let comment of commentList">
                                        <span class="d-flex align-items-center"><img
                                                src="{{userInform?.userImagePath ? userInform?.userImagePath : 'assets/images/userLogo.png'}}"
                                                alt=""> {{comment?.createdBy}}</span>
                                        <p class="mb-0">{{comment?.commentText}}</p>
                                        <small class="d-flex justify-content-between">Posted On: {{comment?.createdDate
                                            | date}} <mat-icon (click)="deleteComment(comment?.commentId)">delete
                                            </mat-icon>
                                        </small>
                                    </div>
                                </ng-container>
                            </div>
                        </mat-dialog-content>
                        <form (ngSubmit)="mes.form.valid && messageSubmit()" #mes="ngForm">
                            <input placeholder="Add a comment" required [(ngModel)]="messageModal.documentRemarks"
                                name="documentRemarks" class="comment-input">
                            <!-- <div class="d-flex justify-content-end">
                            <button mat-mini-fab color="primary" [disabled]="!mes.valid">
                                <mat-icon>send</mat-icon>
                            </button>
                        </div> -->
                        </form>
                    </mat-tab>
                    <mat-tab label="Activity Log">
                        <mat-dialog-content>
                            <div class="allact" *ngFor="let list of actList">
                                <div class="d-flex justify-content-between align-items-center titdate">
                                    <ng-container *ngIf="list?.sharedWith; else otherText">
                                        <p class="mb-0">
                                            {{list?.createdBy}} {{list?.activityType}} {{list?.sharedWith}}
                                            <br>
                                            <button mat-flat-button color="primary" class="text-uppercase stopshar-btn"
                                                (click)="stopSharing(list?.documentSharingId)"
                                                *ngIf="(userInform?.userId == list?.sharedById) && list?.sharedWithId != 0">Stop
                                                Sharing</button>
                                        </p>
                                    </ng-container>
                                    <ng-template #otherText>
                                        {{list?.createdBy}} {{list?.activityType}}
                                    </ng-template>
                                    <span>{{list?.createdDate | date}}</span>
                                </div>
                                <!-- <p class="docname d-flex align-items-center">
                                    <label class="lableext formtLable">pdf</label>
                                    {{list?.documentName}}
                                </p> -->
                            </div>
                        </mat-dialog-content>
                    </mat-tab>
                    <mat-tab label="Version History">
                        <mat-dialog-content>
                            <div class="allact d-flex align-items-center justify-content-between" *ngFor=" let list of
                                docData?.documentVersionIds">
                                <a class="docname d-flex align-items-center" (click)="getDocument(list?.documentId)"
                                    [class.active]="list?.documentId == docData?.documentId">
                                    <label class="lableext formtLable">pdf</label>
                                    {{list?.documentName}}
                                </a>
                                <div class="titdate">
                                    <span>{{list?.createdDate | date}}</span>
                                </div>
                            </div>
                        </mat-dialog-content>
                    </mat-tab>
                </mat-tab-group>
            </div>
        </div>
    </div>
</div>